import { useCallback, useEffect, useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { endpoints } from "../lib/api";

const Light = ({ ok, disabled }) => {
  const color = disabled
    ? "bg-zinc-600"
    : ok
      ? "bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.8)]"
      : "bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)]";
  return <span className={`inline-block w-2.5 h-2.5 rounded-full ${color}`} />;
};

const RowStatus = ({ testid, name, res }) => {
  const disabled = !!res?.disabled;
  const ok = !!res?.ok;
  const label = disabled ? "OFF" : ok ? "ONLINE" : "DOWN";
  const labelColor = disabled ? "text-zinc-500" : ok ? "text-emerald-400" : "text-red-400";
  return (
    <div data-testid={testid} className="flex items-center justify-between border-b border-border pb-2 last:border-0 last:pb-0">
      <div className="flex items-center gap-2">
        <Light ok={ok} disabled={disabled} />
        <span className="font-mono text-[11px] uppercase tracking-widest text-white">{name}</span>
      </div>
      <div className="text-right">
        <span className={`font-mono text-[10px] uppercase tracking-widest ${labelColor}`}>{label}</span>
        {!ok && !disabled && res?.detail && (
          <div className="text-[10px] text-muted-foreground max-w-[180px] truncate" title={res.detail}>
            {res.detail}
          </div>
        )}
      </div>
    </div>
  );
};

export default function AIHealthPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (force = false) => {
    setLoading(true);
    try {
      const { data: d } = await endpoints.aiHealth(force);
      setData(d);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(() => load(), 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div data-testid="ai-health-panel" className="border border-border rounded-sm bg-[#0d0d0d] p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          AI Health Status
        </h3>
        <button
          data-testid="ai-health-refresh-btn"
          onClick={() => load(true)}
          disabled={loading}
          className="text-muted-foreground hover:text-white transition-colors disabled:opacity-40"
          title="Refresh status"
        >
          <ArrowsClockwise size={13} className={loading ? "animate-spin" : ""} />
        </button>
      </div>
      {!data ? (
        <div className="text-[11px] text-muted-foreground">{loading ? "Checking..." : "Status unavailable"}</div>
      ) : (
        <div className="space-y-2">
          <RowStatus testid="ai-health-neurobro" name="Neurobro AI" res={data.neurobro} />
          <RowStatus testid="ai-health-claude" name="Claude AI" res={data.claude} />
          <RowStatus testid="ai-health-funding" name="Funding Data" res={data.funding} />
        </div>
      )}
    </div>
  );
}
